import antd, { Form, Collapse, Row, Col } from 'antd';
import styled from 'styled-components';
import ScreenHelper from 'components/Styled/ScreenHelper';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';

export const StyleCargoChargesForm = styled(Form)`
  ${ScreenHelper.up('lg', 'xl')`
     font-size: 17px; 
     margin-top: 50px;
    }
`}
`;

//in use - results
export const StyleCargoChargesResultContainer = styled(Col)`
    margin-top: 30px;
    ${ScreenHelper.down('sm', 'xs')`
      margin-top: 20px;
    `}
  }
`;

//in use - form
export const StyleCargoChargesRow = styled(Row)`
  margin-bottom: 20px;
  .datePicker {
    width: 100%;
  }

  ${ScreenHelper.down('sm', 'xs')`
margin-top: 15px;
  }
  `}
`;

//in use - list
export const StyleCargoChargesPanel = styled(CollapsePanel)`
  ${ScreenHelper.up('lg', 'xl')`
    font-size: 17px; 
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 14px 45px 14px;
  }
  `}

  .table-header {
    font-size: 17px;
  }
`;

export const StyleCargoChargesCollapse = styled(Collapse)`
  text-align: left;
`;
